import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from 'emotion-theming';
import PriveComponent from '@nykaa/cart-shared/components/Prive';
import { CART_TEXT_MESSAGES } from '@nykaa/cart-shared/constants/message';
import { stringInterpolation } from '@nykaa/cart-shared/helpers/utils';
import { deviceTypes, PriveBand } from '@nykaa/cart-shared/constants';
import { IPrive } from '@nykaa/cart-shared/components/Prive/types';
import { State } from 'store/types';

const Prive = () => {
  const theme: Theme = useTheme();
  const { rewardsDTO } = useSelector(
    (state: State) => state.cartReducer.cartInfo
  );

  const { rewardPointsRecieve = 0, baseRewardPoints = 0 } = rewardsDTO || {};

  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const {
    REDEEM_POINTS_ON_YOUR_NEXT_ORDER,
    EARN_DYNAMIC_REWARD_POINTS,
    REDEEM_TO_GET_A_DISCOUNT_ON_YOUR_NEXT_ORDER,
    YOUR_POINTS_WILL_GET_CREDITED_TO_YOUR_ACCOUNT_AFTER_ORDER_DELIVERY,
    POINTS_WILL_GET_CREDITED_TO_YOUR_ACCOUNT_ONCE_YOUR_ORDER_IS_DELIVERED,
    DYNAMIC_MULTIPLIER_APPLIED_ON_YOUR_POINTS,
    BASE_REWARD_POINTS,
    GOT_IT,
    DYNAMIC_POINTS,
  } = CART_TEXT_MESSAGES;

  const rewardPoints = Math.round(rewardPointsRecieve || 0);
  const baseRewardPoint = Math.round(baseRewardPoints || 0);

  const earnDynamicPointsFallback = stringInterpolation(
    EARN_DYNAMIC_REWARD_POINTS,
    { rewardPoints: rewardPoints }
  );
  const dynamicPointsFallback = stringInterpolation(DYNAMIC_POINTS, {
    rewardPoints: rewardPoints,
  });
  const dynamicBasePointsFallback = stringInterpolation(DYNAMIC_POINTS, {
    rewardPoints: baseRewardPoint,
  });

  const priveBand = rewardsDTO?.priveBand || PriveBand.non_member;

  const priveTitle = earnDynamicPointsFallback;
  let priveSubtitleTop = REDEEM_POINTS_ON_YOUR_NEXT_ORDER;
  const priveSubtitleBottom = '';
  const bottomSheetTitle = earnDynamicPointsFallback;
  let bottomsheetKeyValuePair: any;
  let bottomSheetInfoMessage =
    POINTS_WILL_GET_CREDITED_TO_YOUR_ACCOUNT_ONCE_YOUR_ORDER_IS_DELIVERED;

  if (priveBand == PriveBand.non_member) {
    priveSubtitleTop = REDEEM_TO_GET_A_DISCOUNT_ON_YOUR_NEXT_ORDER;
    bottomsheetKeyValuePair = [
      {
        bottomsheetKeyHTML:
          YOUR_POINTS_WILL_GET_CREDITED_TO_YOUR_ACCOUNT_AFTER_ORDER_DELIVERY,
        bottomsheetKeyTypography: theme.typography.bodyMedium,
        bottomsheetKeyColor: theme.colors.textSecondary,
      },
    ];
    bottomSheetInfoMessage = rewardsDTO?.priveThresholdMessage || '';
  }

  if ((rewardsDTO?.cartRewardsMultiplier || 0) > 1) {
    priveSubtitleTop = stringInterpolation(
      DYNAMIC_MULTIPLIER_APPLIED_ON_YOUR_POINTS,
      { multiplier: rewardsDTO?.cartRewardsMultiplier || 0 }
    );
    bottomsheetKeyValuePair = [
      {
        bottomsheetKeyHTML: `<del>${BASE_REWARD_POINTS}</del>`,
        bottomsheetValueHTML: `<del>${dynamicBasePointsFallback}</del>`,
        bottomsheetKeyTypography: theme.typography.bodyMedium,
        bottomsheetValueTypography: theme.typography.bodyMedium,
        bottomsheetKeyColor: theme.colors.textDisabled,
        bottomsheetValueColor: theme.colors.textDisabled,
      },
      {
        bottomsheetKeyHTML: `${rewardsDTO?.cartRewardsMultiplier}x ${
          rewardsDTO?.commonRulesDescription || ''
        }`,
        bottomsheetValueHTML: dynamicPointsFallback,
        bottomsheetKeyTypography: theme.typography.bodyMedium,
        bottomsheetValueTypography: theme.typography.bodyMedium,
        bottomsheetKeyColor: theme.colors.textSecondary,
        bottomsheetValueColor: theme.colors.textSecondary,
      },
    ];
  }

  const toggleBottomSheet = () => setShowBottomSheet((status) => !status);

  const priveProps: IPrive = {
    title: priveTitle,
    priveBand: priveBand as any,
    subtitleTop: priveSubtitleTop,
    bottomSheetInfoMessage: bottomSheetInfoMessage,
    bottomSheetTitle: bottomSheetTitle,
    BottomSheetCTA: {
      text: GOT_IT,
      onClick: toggleBottomSheet,
    },
    bottomsheetKeyValuePair: bottomsheetKeyValuePair,
    showBottomsheet: showBottomSheet,
    subtitleBottom: priveSubtitleBottom,
    onIconClick: toggleBottomSheet,
    onBottomsheetClose: toggleBottomSheet,
    deviceType: deviceTypes.DESKTOP,
  };

  if (!rewardPoints) {
    return null;
  }

  return <PriveComponent {...priveProps} />;
};

export default Prive;
